/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { AgentConversation, EntityId, List } from "./data-contracts";

/**
 * @description Returns a paginated list of AI agent conversations that were created in the context of this change request. These conversations capture the AI-assisted editing sessions that contributed to the draft. Use this to review the history of AI interactions on a change request before merging.
 * @tags change-request-conversations
 * @name ListChangeRequestConversations
 * @summary List AI agent conversations associated with a change request
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/conversations
 * @secure
 */

// @ts-ignore
export const listChangeRequestConversations: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: AgentConversation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/conversations",
  method: "get",
  streaming: false,
  tags: ["change-request-conversations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates a specific AI agent conversation associated with a change request. Use this to rename the conversation.
 * @tags change-request-conversations
 * @name UpdateChangeRequestConversation
 * @summary Update an AI agent conversation on a change request
 * @request PATCH:/spaces/{spaceId}/change-requests/{changeRequestId}/conversations/{conversationId}
 * @secure
 */

// @ts-ignore
export const updateChangeRequestConversation: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique ID of the agent conversation (its client-generated local id, or "default" for the default conversation) */
    conversationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The new title of the conversation. */
    title: string;
  };
  RequestHeaders: {};
  ResponseBody: AgentConversation;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/conversations/{conversationId}",
  method: "patch",
  streaming: false,
  tags: ["change-request-conversations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-conversations
 * @name DeleteChangeRequestConversation
 * @summary Delete an agent conversation
 * @request DELETE:/spaces/{spaceId}/change-requests/{changeRequestId}/conversations/{conversationId}
 * @secure
 */

// @ts-ignore
export const deleteChangeRequestConversation: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique ID of the agent conversation (its client-generated local id, or "default" for the default conversation) */
    conversationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 205;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/conversations/{conversationId}",
  method: "delete",
  streaming: false,
  tags: ["change-request-conversations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
